import React, {useState} from "react";
import Header from "../Components/Header/Header";
import { db } from "../firebase";
import {ref, set, update, push, child, } from 'firebase/database';


export default AddNewCollector =>{

    const [newCollectorData, setNewCollectorData] = useState({
        collectorName: "",
        email: "",
        contactNo: "",
        company:"company1",
        status: "active",
        password: "",
        lastUpdated:"", 
        assignedRoute:{
            IsAssigned: false,
            assignedRouteId: [],
        },
        
      });

    const handleChange = (event) => {
    const { name, value } = event.target;
    setNewCollectorData((prevData) => ({ ...prevData, [name]: value }));
    console.log(value)
    };

    
    

    const handleSubmit = (event) => {
        event.preventDefault();
        const currentTime = new Date().toLocaleString();

        const collectorId = push(child(ref(db), 'workers')).key;
        const collectorData = {
            [collectorId]: {
              name: newCollectorData.collectorName,
              email: newCollectorData.email,
              password: newCollectorData.password,
              contactNumber: newCollectorData.contactNo,
              company: newCollectorData.company,
              status: newCollectorData.status,
              lastUpdated: currentTime, 
              assignedRoute:{
                IsAssigned: false,
                assignedRouteId: [],
              },
            }
          };


        const newCollectorRef = ref(db, 'workers/');
        update(newCollectorRef, collectorData)
        .then(()=>{
            alert('collector is registered')
            // Clear the form
            setNewCollectorData({
                collectorName: "",
                email: "",
                contactNo: "",
                company:"company1",
                status:"active",
                assignedRoute:{
                    IsAssigned: false,
                    assignedRouteId: [],
                }
          });
            // const colName = document.getElementById('collecterName');
            // colName.value = '';

          console.log('success: data is submitted')
        })

    }

    return(
        <>
            <Header />  
            <div class="flex  justify-center space-x-8 mt-10">
                <div
                    class=" w-1/3   bg-gray-800  border-gray-200 rounded-lg    sm:p-6 md:p-8 dark:bg-gray-800 dark:border-gray-700">
                    <form class="collector-form space-y-6" onSubmit={handleSubmit}>
                        <h1 class="text-xl font-medium text-white dark:text-white text-center">Add new Collecter</h1>

                        <div>
                            <label for="collectorName" class="block mb-2 text-sm font-medium text-white dark:text-white">Collecter
                                Name</label>
                            <input type="text" name="collectorName" id="collecterName" 
                                class="bg-gray-800 border  border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                placeholder="Add collecter Name" requireds  value={newCollectorData.collectorName} onChange={(e) => handleChange(e)} />
                        </div>
                        
                        <div>
                            <label for="Email" class="block mb-2 text-sm font-medium text-white dark:text-white">Email</label>
                            <input data-testid="email-input" type="email" name="email" id=" collecterEmail" value={newCollectorData.email} onChange={handleChange}
                                class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                placeholder="Add Email" required />
                        </div>


                        <div>
                            <label for="password" class="block mb-2 text-sm font-medium text-white">password</label>
                            <input data-testid="password-input" type="text" name="password" id="password" placeholder="Add password" value={newCollectorData.password} onChange={handleChange}
                                class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                required />
                        </div>


                        <div>
                            <label for="Collecter Number"
                                class="block mb-2 text-sm font-medium text-white dark:text-white">Contact Number</label>
                            <input type="tel" name="contactNo" id="contactnumber" value={newCollectorData.contactNo}  onChange={handleChange}
                                class="bg-gray-800 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                placeholder="+92........." required />
                        </div>

                        <button type="submit"
                            class="w-full h-8 text-white bg-gray-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5  text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Register Collecter
                        </button>

                    </form>
                </div>
                <div class=" mt-10">
                    <figure class="">
                        <img src="images/van.png" alt="bin" class="h-1/3 w-96 mt-10 text-white" />
                    </figure>
                </div>

            </div>
        </>
    )
}